module.exports = __webpack_public_path__ + "static/img/7.00d7ac9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/7.png
// module id = KQq2
// module chunks = 0